<template>
  <div>
    <v-row class="pa-5">
      <v-col class="px-3">
        <v-row no-gutters align="center">
          <h5 class="greyBold--text font-weight-bold mb-0">{{$t('common:facility_plural')}}</h5>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs}">
              <v-btn class="ml-2" icon @click="cardView = !cardView" v-bind="attrs" v-on="on">
                <v-icon>list_alt</v-icon>
              </v-btn>
            </template>
            <span v-if="cardView">{{ $t('buttons:table-view') }}</span>
            <span v-else>{{ $t('buttons:card-view') }}</span>
          </v-tooltip>
        </v-row>

      </v-col>
      <!-- TODO add search field for cardView -->
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <BaseButton
            color="primary"
            :btn-text="$t('buttons:add-specific', { specific: $t('common:facility')})"
            icon="add"
            @clickedButton="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities?building=${$route.params.id}`)"
        />
      </v-col>
      <v-col cols="12" class="pt-0" v-if="!cardView">

         <DataTablePaginated
          ref="table"
          :headers="facilityTableHeaders"
          icon="open_in_new"
          :iconTooltip="$t('book/building:building.page-content.facility-dashboard.view')"
          @clickedButton1="viewFacility"
          @updateTableData="updateData"
          sortBy="name"
          :cachedSearch="$store.state.book.building.facilitiesSearch"
          @cacheCommit="$store.commit('book/building/storeFacilitiesSearch', $event)"
        />

      </v-col>

    </v-row>
    <div v-if="cardView" class="px-5">
     <SearchAndSortBar
        @updateData="updateData"
        @cacheCommit="$store.commit('book/building/storeFacilitiesSearch', $event)"
        :cachedSearch="$store.state.book.building.facilitiesSearch"
        :sorts="facilityTableHeaders"
        disable-filter
        default-sort-by="name"
      />
      <v-row>
        <v-col cols="12" md="12" :lg="cardSize" xl="6" v-for="(item, i) in restFacilities.content" :key="i" >
          <ItemCard
              :item="item"
              :title="item.name"
              :titleExtra="'bei ' + item.buildingName"
              :subtitle="item.buildingStreet + ', ' + item.buildingZip + ', ' + item.buildingCity"
              :subtitle2="$t('common:facility-number') + ': ' + item.objectNumber"
              :subtitle3="item.typeName"
              :actionBtn1Text="$t('common:documentation')"
              :actionBtn2Text="$t('common:contract')"
              :actionBtn3Text="$t('common:process')"
              :actionBtn1Tooltip="$t('book/building:building.page-content.facility-dashboard.add-docu')"
              :actionBtn2Tooltip="$t('book/building:building.page-content.facility-dashboard.add-contract')"
              :actionBtn3Tooltip="$t('book/building:building.page-content.facility-dashboard.add-process')"
              @viewItem="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}`)"
              :viewBtnTooltip="$t('book/building:building.page-content.facility-dashboard.view')"
              @cardAction1="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}/info/documentations`)"
              @cardAction2="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}/info/contracts`)"
              @cardAction3="$router.push(`/${$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}/info/processes`)"
              :left-corner-icon-source="item.typeIconUrl"
              :show-deactivated-facility-icon = "!item.active"
          />
        </v-col>
    </v-row>
    <v-pagination v-if="this.restFacilities.content.length != 0"
        v-model="restFacilities.options.page"
        :length="totalPages"
        :total-visible="7"
    ></v-pagination>
    <h5 v-else-if="this.restFacilities.content.length == 0" class="greyTint--text mb-0 mt-5 text-center">{{ $t('common:no-data-found') }}</h5>
    </div>
  </div>
</template>

<script>
import BuildingService from "@/modules/book/services/building-service";

import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

import Facility from "@/modules/book/data/facility";
import Building from "@/modules/book/data/building";

import SearchAndSortBar from "@/modules/core/components/SearchAndSortBar";

import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";

import BaseButton from "@/modules/core/components/Base/BaseButton";

import {mapState} from 'vuex'

import ItemCard from '@/modules/core/components/ItemCard'

export default {
  name: 'BuildingFacilityTab',
  components: {
    DataTablePaginated,
    BaseButton,
    ItemCard,
    SearchAndSortBar
  },
  data() {
    return {      
      cardView: true,
      building: new Building(),
      totalPages: null,            
     
      restFacilities: {
        options: [],
        search: [],
        content: []
      },
    }
  },
  computed: {
    facilityTableHeaders() {
      return [
        {text: this.$t("common:name"), value: "name"},
        {text: this.$t("common:type"), value: "typeName"},
        {text: this.$t("common:address"), value: "buildingStreet"},
        {text: this.$t("common:object-number"), value: "objectNumber"},
        {text: this.$t("book/building:building.page-content.facility-dashboard.view"), value: "controls", sortable: false},
      ];
    },

    cardSize() {
      // if both sidebars are fully opened, make card size bigger
      if(this.leftBuildingDrawer && this.rightBuildingDrawer) {
        return '12'
        // if both side bars are closed, make card size smaller
      } else if(!this.leftBuildingDrawer && !this.rightBuildingDrawer) {
        return '6'
      } else {
        return '12'
      }
    },

    ...mapState('book/layout', {
      leftBuildingDrawer: state => state.leftBuildingDrawer,
      rightBuildingDrawer: state => state.rightBuildingDrawer
    }),
  },
  methods: {

     updateData(options, search) {
  
      if(!search) search = '';

      this.restFacilities.options = options;
      this.restFacilities.search = search;

      if(!this.cardView) {
        this.$refs.table.loading = true;
      }

      BuildingService.readAllPaginatedFacilitiesForBuilding(this.$route.params.id,
      options.page - 1,
      options.itemsPerPage,
      search,
      options.sortBy,
      options.sortDesc,
        (res) => {
          res.data.content.forEach((facility) => {
            if (facility.typeIconUrl) {
              facility.typeIconUrl = process.env.VUE_APP_ROOT_HOST + facility.typeIconUrl;
            }
          })

          if(this.cardView) {
            this.restFacilities.content = DataUtils.parseDataToObjectArray(res.data.content, Facility);
            this.totalPages = res.data.totalPages;                  
          } else {
            this.$refs.table.fillTableData(res.data);
          }
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:facility_plural')}))
          this.$logger.error(error);
        }
      )
    },
    viewFacility(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${item.id}`);
    }
  },
  created() {

  }
}
</script>
